import { render } from "./BaixaTitulosModal.vue?vue&type=template&id=1a7933a5&scoped=true&ts=true"
import script from "./BaixaTitulosModal.vue?vue&type=script&lang=ts"
export * from "./BaixaTitulosModal.vue?vue&type=script&lang=ts"

import "./BaixaTitulosModal.vue?vue&type=style&index=0&id=1a7933a5&scoped=true&lang=css"

import exportComponent from "D:\\Desenvolvimento\\NeoXApp\\NeoX.Frontend\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a7933a5"]])

export default __exports__